import React, { Component } from 'react';
import './WizardFooter.css';
import { NavLink } from "react-router-dom";
import FindIndex from './FindIndex';
import history from './History';
import { withTranslation, Trans } from 'react-i18next';

class WizardFooter extends Component {

    constructor(props) {
        super(props);
        this.footerRef = React.createRef();
        this.resizeObserver = null;
        this.updateLayoutMetrics = this.updateLayoutMetrics.bind(this);
    }

    componentDidMount() {
        this.updateLayoutMetrics();
        if (typeof window.ResizeObserver !== 'undefined' && this.footerRef.current) {
            this.resizeObserver = new window.ResizeObserver(this.updateLayoutMetrics);
            this.resizeObserver.observe(this.footerRef.current);
        }
        window.addEventListener('resize', this.updateLayoutMetrics);
        window.addEventListener('orientationchange', this.updateLayoutMetrics);
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.updateLayoutMetrics);
        }
    }

    componentDidUpdate() {
        this.updateLayoutMetrics();
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this._handleKeyDown);
        window.removeEventListener('resize', this.updateLayoutMetrics);
        window.removeEventListener('orientationchange', this.updateLayoutMetrics);
        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', this.updateLayoutMetrics);
        }
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
        document.documentElement.style.removeProperty('--wizard-footer-height');
        document.documentElement.style.removeProperty('--app-height');
        const layout = document.querySelector('.App-layout');
        if (layout) {
            layout.style.removeProperty('height');
        }
    }

    updateLayoutMetrics() {
        const root = document.documentElement;

        const footerHeight = this.footerRef.current
            ? this.footerRef.current.offsetHeight
            : 0;
        if (footerHeight) {
            root.style.setProperty('--wizard-footer-height', footerHeight + 'px');
        }

        // The truly-visible height on mobile (accounts for the browser toolbar),
        // independent of whether the browser honors svh/dvh CSS units.
        const visibleHeight =
            (window.visualViewport && Math.round(window.visualViewport.height)) ||
            window.innerHeight;
        if (visibleHeight) {
            root.style.setProperty('--app-height', visibleHeight + 'px');
        }

        // Bulletproof: on mobile, force the layout shell to exactly the visible
        // height via an inline style (which beats any CSS unit). This guarantees
        // the flex column (header / scrolling options / footer) fits the screen,
        // so the footer can never overlap the options.
        const layout = document.querySelector('.App-layout');
        if (layout) {
            if (window.innerWidth <= 768 && visibleHeight) {
                layout.style.height = visibleHeight + 'px';
            } else {
                layout.style.removeProperty('height');
            }
        }
    }

    UNSAFE_componentWillMount() {
        this._handleKeyDown = this._handleKeyDown.bind(this);
        document.addEventListener("keydown", this._handleKeyDown);
    }

    _handleKeyDown(event) {
        const steps = this.props.steps;
        const navIndex = FindIndex(steps, s => s.url === this.props.currentStep);
        const prevStep = steps[Math.max(navIndex - 1, 0)];
        const nextStep = steps[Math.min(navIndex + 1, steps.length - 1)];
        const RIGHT = 39;
        const LEFT = 37;

        switch (event.keyCode) {
            case RIGHT:
                history.push(nextStep.url);
                break;
            case LEFT:
                history.push(prevStep.url);
                break;
            default:
                break;
        }
    }

    render() {
        const steps = this.props.steps;
        
        const navIndex = FindIndex(steps, s => s.url === this.props.currentStep);
        const prevStep = steps[Math.max(navIndex - 1, 0)];
        const nextStep = steps[Math.min(navIndex + 1, steps.length - 1)];

        return (
            <div className="wizardFooter" ref={this.footerRef}>
                <div className="wizardFooterInner">
                    <div className="wizardFooterContent">
                        <NavLink to={prevStep.url} className={"prev" + ((navIndex === 0) ? ' hidden' : '')}><Trans defaults='Back' /></NavLink>

                        <span className="index">
                            <Trans defaults='Step' /><Trans defaults=' {{currentpage}}/{{pageCount}}' values={{ currentpage: navIndex + 1, pageCount: steps.length }} />
                        </span>

                        <NavLink to={nextStep.url} className={"next" + ((navIndex === steps.length - 1) ? ' hidden' : '')}><Trans defaults='Next step' /></NavLink>
                    </div>
                    <a className="poweredBy" href="http://3d-animation.dk" target="_blank" rel="noopener noreferrer"><Trans defaults='powered by: 3D Animation ApS' /></a>
                </div>
            </div>
        );
    }
}

export default withTranslation() (WizardFooter);


// WEBPACK FOOTER //
// ./src/WizardFooter.js